import { DataSender } from '../loaders'
/**
* Tracking
*/

class Tracking {
    constructor() {
        this.debug = false;
        this.local = (window.location.host == 'local.evedo.co');
    }

    featured(type, id, action, position) {
        new DataSender({
            data: {
                type: type,
                id: id,
                action: action,
                position: position
            },
            url: '/common/featured/track/'
        });
    }

    featuredClick(type, id, position) {
        this.featured(type, id, 'click', position);
    }

    featuredDisplay(type, id, position) {
        this.featured(type, id, 'display', position);
    }

    featuredCampaign(id, action, position) {
        new DataSender({
            data: {
                id: id,
                action: action,
                position: position
            },
            url: '/common/featured/track-campaign/'
        });
    }

    featuredCampaignClick(id, position) {
        this.featuredCampaign(id, 'click', position);
    }

    featuredCampaignDisplay(id, position) {
        this.featuredCampaign(id, 'display', position);
    }
}

export { Tracking }
